export default "__VITE_ASSET__DeP4SMw5__"